import { render, staticRenderFns } from "./_invoice.vue?vue&type=template&id=10d8026f"
import script from "./_invoice.vue?vue&type=script&lang=js"
export * from "./_invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports